import Vue from "vue";
import Vuex from "vuex";
import Photos from "@/controller/photos";
//import VuexPersistence from "vuex-persist";

//const vuexLocal = new VuexPersistence({
//    storage: window.localStorage,
//    filter: (mutation) => ![
//        "setDownloadAllVexDataStatus",
//        "addPhotoNoEdit",
//        "clearPhotoNoEdit",
//    ].includes(mutation.type)
//});

Vue.use(Vuex);

let store = new Vuex.Store({
    //plugins: [
    //    vuexLocal.plugin
    //],
    state: {
        enterprise: {
            enterprise: null,
            id: null,
            idEnterprise: null,
            name: null,
            type: null,
            active: null,
        },
        inspectionData: {
            operation: {},
            quiz: null,
            clientSignaturePoints: null,
            inspectorSignaturePoints: null,
            clientRg: null,
            clientFullName: null,
            clientPhoneNumber: null,
            numberPlate: null,
            quizType: null,
            quizId: null,
            fotoTirada: null,
            data: {},
            photoNoEdit: null,
            templates: [],
            photos: [],
            requiredPhotos: [],
            additionalPhotos: [],
            breakdownPhotos: [],
            signatures: [],
            coordGps: null
        },
        sizePhoto: {
            width: null,
            height: null,
        },
        inspectionPhases: {
            data: false,
            quiz: false,
            inspectorSignature: false,
            clientSignature: false,
            photosGrid: false,
        },
        downloadAllVexDataStatus: {
            status: undefined,
            percentage: 0,
        },
        uploadChangelog: {
            logArray: [],
        },
        options: {
            lastSelectedCameraId: null
        }
    },
    mutations: {
        setDownloadAllVexDataStatus(state, status) {
            state.downloadAllVexDataStatus.status = status.status;
            state.downloadAllVexDataStatus.percentage = status.percentage;
        },
        setEnterpriseName(state, enterprise) {
            state.enterprise.enterprise = enterprise;
        },
        setEnterpriseId(state, id) {
            state.enterprise.id = id;
        },
        setEnterpriseUserName(state, name) {
            state.enterprise.name = name;
        },
        setUserType(state, type) {
            state.enterprise.type = type;
        },
        setEnterpriseActive(state, active) {
            state.enterprise.active = active;
        },
        setIdEnterprise(state, id) {
            state.enterprise.idEnterprise = id;
        },
        setInspectorSignaturePoints(state, signaturePoints) {
            state.inspectionData.inspectorSignaturePoints = signaturePoints;
        },
        setClientSignaturePoints(state, signaturePoints) {
            state.inspectionData.clientSignaturePoints = signaturePoints;
        },
        setClientRg(state, rg) {
            state.inspectionData.clientRg = rg;
        },
        setClientFullName(state, fullName) {
            state.inspectionData.clientFullName = fullName;
        },
        setClientPhoneNumber(state, phoneNumber) {
            state.inspectionData.clientPhoneNumber = phoneNumber;
        },
        setNumberPlate(state, numberPlate) {
            state.inspectionData.numberPlate = numberPlate;
        },
        setSelectedTemplate(state, templates) {
            state.inspectionData.templates = templates;
            state.inspectionData.requiredPhotos = [...templates];
            if(!templates || templates?.length === 0) {
                this.commit("photosDone", true);
            }
        },
        setSizePhoto(state, sizePhoto) {
            state.sizePhoto.width = sizePhoto.width;
            state.sizePhoto.height = sizePhoto.height;
        },
        addPhotoNoEdit(state, photo) {
            state.inspectionData.photoNoEdit = photo;
        },
        clearPhotoNoEdit(state) {
            state.inspectionData.photoNoEdit = null;
        },
        setPhotoEdited(state, info) {
            state.inspectionData.requiredPhotos.push(info);
        },
        setAllPhotos(state, allPhotos) {
            const photosController = new Photos();
            state.inspectionData.photos = allPhotos;
            const allPhotosDone = photosController.takenAllPhotos(allPhotos);
            this.commit("photosDone", allPhotosDone);
        },
        setSignature(state, signature) {
            state.inspectionData.signatures.push(signature);
        },
        setOperation(state, operation) {
            state.inspectionData.operation = operation;
        },
        setCoordGps(state, coordGps) {
            state.inspectionData.coordGps = coordGps;
        },
        setQuizType(state, type) {
            state.inspectionData.quizType = type;
        },
        setQuizId(state, id) {
            state.inspectionData.quizId = id;
        },
        setQuizQuestions(state, questionQuiz) {
            //questionQuiz is an array of objects that contains the data retrieve from the server and the value of the button selected
            state.inspectionData.quiz = questionQuiz;
        },
        setQuizFieldValue(state, quizField) {
            state.inspectionData.quiz.forEach((field) => {
                if (field.Pergunta.Descricao === quizField.nameField) {
                    field.Resposta = quizField.buttonSelected;
                    field.Avaria = quizField.avaria;
                }
            });
        },
        setData(state, data) {
            //data is an object with the field description as the key;
            state.inspectionData.data = data;
        },
        setLastSelectedCameraId(state, deviceId){
            state.options.lastSelectedCameraId = deviceId;
        },
        quizDone(state) {
            state.inspectionPhases.quiz = true;
        },
        setInspectorSigComplete(state, done) {
            state.inspectionPhases.inspectorSignature = done;
        },
        setClientSigComplete(state, done) {
            state.inspectionPhases.clientSignature = done;
        },
        dataDone(state) {
            state.inspectionPhases.data = true;
        },
        photosDone(state, done) {
            state.inspectionPhases.photosGrid = done;
        },
        clearInspData(state) {
            state.inspectionData.photos = [];
            state.inspectionData.requiredPhotos = [];
            state.inspectionData.additionalPhotos = [];
            state.inspectionData.breakdownPhotos = [];
            state.inspectionData.templates = [];
            state.inspectionData.quiz = null;
            state.inspectionData.clientSignature = null;
            state.inspectionData.inspectorSignature = null;
            state.inspectionData.clientSignaturePoints = null;
            state.inspectionData.inspectorSignaturePoints = null;
            state.inspectionData.clientRg = null;
            state.inspectionData.clientFullName = null;
            state.inspectionData.clientPhoneNumber = null;
            state.inspectionData.numberPlate = null;
            state.inspectionData.operation = {};
            state.inspectionData.quizType = null;
            state.inspectionData.quizId = null;
            state.inspectionData.photoNoEdit = null;
            state.inspectionData.data = {};
            state.sizePhoto.width = null;
            state.sizePhoto.height = null;
            state.inspectionPhases.data = false;
            state.inspectionPhases.quiz = false;
            state.inspectionPhases.inspectorSignature = false;
            state.inspectionPhases.clientSignature = false;
            state.inspectionPhases.photosGrid = false;
        },
        updateLogArray(state, newLog) {
            state.uploadChangelog.logArray.push(newLog);
        },
        clearLogArray(state) {
            state.uploadChangelog.logArray = [];
        },
    },
    actions: {
        updatePhotos({ commit, state }, photosCollection) {
            let requiredPhotos = state.inspectionData.requiredPhotos;
            let additionalPhotos = state.inspectionData.additionalPhotos;
            let breakdownPhotos = state.inspectionData.breakdownPhotos;
            let allPhotos = [];

            if (photosCollection) {
                if (photosCollection.collectionId === "requiredPhotos") {
                    requiredPhotos = photosCollection.photos;
                } else if (photosCollection.collectionId === "additionalPhotos") {
                    additionalPhotos = photosCollection.photos;
                } else if (photosCollection.collectionId === "breakdownPhotos") {
                    breakdownPhotos = photosCollection.photos;
                }
            }

            allPhotos = allPhotos.concat(
                requiredPhotos,
                additionalPhotos,
                breakdownPhotos
            );

            const allPhotosUpdated = [...allPhotos];

            commit("setAllPhotos", allPhotosUpdated);
        },
    },
    getters: {
        downloadAllVexDataStatus: (state) => {
            return state.downloadAllVexDataStatus;
        },
        downloadAllVexDataPercentage: (state) => {
            return state.downloadAllVexDataStatus;
        },
        enterpriseInfo: (state) => {
            return state.enterprise;
        },
        photos: (state) => {
            return state.inspectionData.requiredPhotos;
        },
        photoNoEdit: (state) => {
            return state.inspectionData.photoNoEdit;
        },
        quizComplete: (state) => {
            let quizComplete = true;
            let questions = state.inspectionData.quiz;
            if (questions != null) {
                for (let i = 0; i < questions.length; i++) {
                    const operationParams = state.inspectionData.operation.parametros;
                    let emptyRequiredField = false;
                    let question = questions[i];
                    let activeQuestion = question.PerguntaEmpresa.Ativa == 1;
                    let requiredQuestion = question.PerguntaEmpresa.Obrigatorio == 1;
                    let requiredQuestionNotFilled = question.Resposta == null;
                    let questionsAnswers = questions[i].Resposta;
                    let numeroDeAvarias = question.Pergunta.Avarias.length;
                    let respostaAvaria = question.Avaria;

                    if (activeQuestion && requiredQuestion) {
                        if (requiredQuestionNotFilled) {
                            emptyRequiredField = true;
                        }
                    }

                    if (emptyRequiredField) {
                        quizComplete = false;
                        break;
                    }
                    if (operationParams.obriga_informe_tipo_avaria != null) {
                        let avariasObrigatorias = operationParams.obriga_informe_tipo_avaria.ativo;
                        if (
                            avariasObrigatorias &&
                            questionsAnswers == "Avariado" &&
                            numeroDeAvarias > 0 &&
                            respostaAvaria == ""
                        ) {
                            quizComplete = false;
                        }
                    }
                }
            }
            return quizComplete;
        },
        phasesDone: (state) => {
            let phasesDone = {
                quiz: state.inspectionPhases.quiz,
                inspectorSignature: state.inspectionPhases.inspectorSignature,
                clientSignature: state.inspectionPhases.clientSignature,
                data: state.inspectionPhases.data,
                photo: state.inspectionPhases.photosGrid,
            };
            return phasesDone;
        },
        allPhasesDone: (state) => {
            return (
                state.inspectionPhases.quiz &&
                state.inspectionPhases.inspectorSignature &&
                state.inspectionPhases.clientSignature &&
                state.inspectionPhases.data &&
                state.inspectionPhases.photosGrid
            );
        },
        allInspectionData: (state) => {
            return [state.enterprise, state.inspectionData, state.inspectionPhases];
        },
    },
});


export default store;